import logoAb4cus from '@/assets/images/logo_ab4cus.png'
import logoBrand from '@/assets/images/logo_basciano_white.svg'
import { Logo } from '@/components/molecules/Logo/Logo'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Typography } from '../../atoms/Typography/Typography'
import { LanguageSelector } from '@/components/molecules/LanguageSelector/LanguageSelector'

interface FooterProps {
  isError?: boolean
}

const Footer: React.FC<FooterProps> = ({ isError = false }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  // Función para manejar el scroll suave
  const handleScroll = (sectionId: string): void => {
    if (isError) {
      navigate('/')
    } else {
      const section = document.getElementById(sectionId)
      if (section != null) {
        section.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <footer className='bg-primary-bold text-white p-2 pt-8 lg:p-8'>
      <div className='container lg:max-w-[1380px] mx-auto grid grid-cols-1 md:grid-cols-4 gap-8'>
        <div className='w-full h-full flex flex-col items-start justify-center flex-1 gap-4'>
          <Logo src={logoBrand} alt='Basciano Trading Logo' width={255} height={71} />
          <LanguageSelector />
        </div>
        <div>
          <Typography variant='h6' className='mb-8 text-[#92989F]'>{t('footer.support')}</Typography>
          <ul className='space-y-2 text-[#E7E7E7]'>
            <li>
              <a onClick={() => handleScroll('home')} className='hover:underline cursor-pointer'>
                {t('footer.phone')}
              </a>
            </li>
            <li>
              <a onClick={() => handleScroll('about')} className='hover:underline cursor-pointer'>
                {t('footer.mail')}
              </a>
            </li>
            <li>
              <a onClick={() => handleScroll('services')} className='hover:underline cursor-pointer'>
                {t('footer.address')}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <Typography variant='h6' className='mb-8 text-[#92989F]'>{t('footer.resource')}</Typography>
          <ul className='space-y-2 text-[#E7E7E7]'>
            <li><a href='#' className='hover:underline'>{t('footer.blog')}</a></li>
            <li><a href='#' className='hover:underline'>{t('footer.linkedin')}</a></li>
          </ul>
        </div>
        <div>
          <Typography variant='h6' className='mb-8 text-[#92989F]'>{t('footer.resource')}</Typography>
          <ul className='space-y-2 text-[#E7E7E7]'>
            <li><a href='#' className='hover:underline'>{t('footer.terms')}</a></li>
            <li><a href='#' className='hover:underline'>{t('footer.policy')}</a></li>
            <li><a href='#' className='hover:underline'>{t('footer.accessibility')}</a></li>
            <li><a href='#' className='hover:underline'>{t('footer.legal')}</a></li>
          </ul>
        </div>
      </div>
      <div className='w-full flex items-center flex-col md:flex-row gap-4 justify-center text-center mt-14 pb-8 lg:pb-0 container lg:max-w-[1380px] mx-auto'>
        <Typography variant='p' className='text-sm'>
          © {new Date().getFullYear()}  Trading Corporation. {t('footer.rights')}
        </Typography>
        <a href='https://www.ab4cus.com/?utm_source=customer&utm_medium=footer&utm_campaign=redirect'><img src={logoAb4cus} alt='Desarrollado por Ab4cus' width={60} /></a>
      </div>
    </footer>
  )
}

export default Footer
